const Orders = () => {
  return <div><a href="https://gianedavicollezioni.com/admintoys/sales/order">Go to Magento order</a></div>;
};

export default Orders;
